<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item
        v-for="item in ruleForm.readingDetails"
        :key="item.paperTypeId"
        :label="item.paperTypeName"
      >
        <el-input-number
          v-model="item.currentCount"
          :min="0"
          label="请输入数量"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="凭证上传" prop="operatorImg">
        <uploadFile v-model="ruleForm.operatorImg" type="avatar"></uploadFile>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
// import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  // props: {
  //   facilityId: {
  //     type: String,
  //     default: "",
  //   },
  //   paperTypeList: {
  //     type: Array,
  //     default: [],
  //   },
  //   searchFun: {
  //     type: Function,
  //     default: () => {},
  //   },
  // },
  data() {
    return {
      ruleForm: {
        readingDetails: [],
        facilityId: null,
      },
      rules: {
        operatorImg: [
          { required: true, message: "请上传凭证", trigger: "change" },
        ],
      },
      forms: {
        avatarStr: "",
      },
      paperTypeList: [],
    };
  },
  created() {
    let query = (this.$route && this.$route.query) || {};
    this.ruleForm.facilityId = query.kv;

    this.getPaperTypeList();
  },
  computed: {},
  methods: {
    submitForm(formName) {
      console.log(this.ruleForm);

      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          $utils.api
            .load(
              `/admin/system/sysFacilityMeterReading`,
              this.ruleForm,
              "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                // this.$Modal.remove();
                // this.$emit("searchFun");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getPaperTypeList() {
      let q = {};
      $utils.api
        .load("/admin/system/paperType/options", q, "get")
        .then((res) => {
          console.log(res);
          this.paperTypeList = res.data;
          this.paperTypeList.forEach((item) => {
            console.log(item);
            let obj = {
              paperTypeName: item.typeName,
              paperTypeId: item.typeId,
              currentCount: 0,
            };

            this.ruleForm.readingDetails.push(obj);
          });
          console.log(this.ruleForm);
        });
    },
    handleSubmit() {
      let q = this.forms;
      q.facilityId = this.facilityId;

      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(22222222);

          this.sloading = true;
        }
      });
    },
  },
};
</script>

<style lang="less">
</style>
